// ------------------------------
var state = {
  codeType: 'pug'
}; // ------------------------------

var getters = {}; // ------------------------------

var mutations = {
  CODETYPE: function CODETYPE(state, data) {
    state.codeType = data;
  }
}; // ------------------------------

var actions = {}; // ------------------------------

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};